import React from 'react';
import { Link } from 'react-router-dom';

export const Terms = () => {
  return (
    <div className="privacy-container">
      {/* Retro grain texture overlay */}
      <div className="grain-overlay"></div>

      <div className="privacy-content">
        <Link to="/" className="privacy-back-link">&larr; Back to Home</Link>

        <h1 className="privacy-title">Terms of Service</h1>

        <div className="privacy-text">
          <p className="privacy-last-updated">Last updated: January 29, 2026</p>
          <div className="privacy-header-info">
            <p>Developer: Jayanth Putta ("Eranos," "we," "us")</p>
            <p>Contact: geteranos@gmail.com</p>
          </div>

          <section className="privacy-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By downloading, installing, or using the Eranos app or visiting our website at geteranos.com, you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the service.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Description of Service</h2>
            <p>
              Eranos is a potluck planning app that helps groups coordinate who is bringing what to shared meals and events. The service includes event creation and management, potluck dish coordination, AI-powered recommendations and recipes, and real-time group collaboration features.
            </p>
          </section>

          <section className="privacy-section">
            <h2>3. User Accounts</h2>
            <p>
              You must create an account using Google Sign-In or Apple Sign-In to use Eranos. You are responsible for maintaining the security of your account and for all activity that occurs under your account. You must provide accurate information during the sign-in process. We reserve the right to suspend or terminate accounts that violate these terms.
            </p>
          </section>

          <section className="privacy-section">
            <h2>4. User-Generated Content</h2>
            <p>
              You retain ownership of the content you create within Eranos, including event details, dish descriptions, and chat messages. By using the service, you grant us a limited license to store, display, and process your content as necessary to provide the service. You are responsible for the content you post and must ensure it does not violate these terms or applicable laws.
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Prohibited Content and Behavior</h2>
            <p>You agree not to use Eranos to:</p>
            <ul>
              <li>Post content that is illegal, harmful, threatening, abusive, harassing, defamatory, or otherwise objectionable</li>
              <li>Impersonate any person or entity, or falsely state or misrepresent your affiliation with a person or entity</li>
              <li>Upload or transmit viruses, malware, or other harmful code</li>
              <li>Attempt to gain unauthorized access to the service, other accounts, or our systems</li>
              <li>Use the service for spam, phishing, or other unsolicited communications</li>
              <li>Interfere with or disrupt the service or servers connected to the service</li>
              <li>Use the service in any way that violates applicable local, state, national, or international law</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>6. Content Moderation</h2>
            <p>
              Event organizers may remove participants and their associated content from events, and may ban participants from rejoining. Users can report events, dishes, or other users for violations. We reserve the right to review reported content and take appropriate action, including removing content or suspending accounts.
            </p>
          </section>

          <section className="privacy-section">
            <h2>7. AI-Generated Content Disclaimer</h2>
            <p>
              Eranos uses AI (powered by OpenAI) to provide dish recommendations, recipes, and chat responses. AI-generated content is provided for informational and entertainment purposes only. We do not guarantee the accuracy, safety, or suitability of AI-generated recommendations or recipes. You are responsible for verifying ingredients, allergens, and preparation instructions. AI-generated content should not be considered professional dietary, nutritional, or medical advice.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Intellectual Property</h2>
            <p>
              The Eranos name, logo, and app design are the property of the developer. You may not copy, modify, distribute, or create derivative works based on the service without our prior written consent. These terms do not grant you any rights to our trademarks, branding, or other intellectual property.
            </p>
          </section>

          <section className="privacy-section">
            <h2>9. Account Termination</h2>
            <p>
              You may delete your account at any time through the app (Profile &rarr; Delete Account) or on the web at <a href="https://www.geteranos.com/delete-account" className="privacy-email-link">geteranos.com/delete-account</a>. Upon deletion, your account data will be handled as described in our <Link to="/privacy" className="privacy-email-link">Privacy Policy</Link>. We reserve the right to suspend or terminate your account if you violate these terms, with or without notice.
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. Limitation of Liability</h2>
            <p>
              Eranos is provided "as is" and "as available" without warranties of any kind, whether express or implied. To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenue, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of the service.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11. Changes to Terms</h2>
            <p>
              We may update these Terms of Service from time to time. We will notify users of material changes by updating the "Last updated" date at the top of this page. Your continued use of the service after changes are posted constitutes your acceptance of the revised terms.
            </p>
          </section>

          <section className="privacy-section">
            <h2>12. Contact</h2>
            <p>
              Questions about these terms: <a href="mailto:geteranos@gmail.com" className="privacy-email-link">geteranos@gmail.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
